import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_membership_report_export_file_hdr_RowClass} from '../../../dbschema';

export class MembershipReportExportContainerModel extends BaseContainerModel {
    bl_fi_membership_report_export_file_hdr: bl_fi_membership_report_export_file_hdr_RowClass = new bl_fi_membership_report_export_file_hdr_RowClass();
}
